const resetFns = new Set();

export function registerSwrReset(fn) {
  resetFns.add(fn);
  return () => resetFns.delete(fn);
}

export function resetAllSwrStores() {
  for (const fn of resetFns) {
    try { fn(); } catch (_) { /* best-effort */ }
  }
}
